import { FC } from 'react'
import {
  Box,
  Button,
  Typography,
  alpha,
  useTheme,
} from '@mui/material'
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined'
import { Link as RouterLink } from 'react-router-dom'
import ApplicationLinks from '../../ApplicationLinks'

export const GstFilingComingSoon: FC = () => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 220px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: { xs: 2, sm: 4 },
        py: { xs: 4, sm: 6 },
        background: `linear-gradient(180deg, ${alpha(
          theme.palette.primary.main,
          0.04
        )} 0%, ${alpha(theme.palette.background.default, 0)} 100%)`,
      }}
    >
      <Box
        sx={{
          maxWidth: 560,
          width: '100%',
          textAlign: 'center',
          p: { xs: 3, sm: 5 },
          borderRadius: 3,
          backgroundColor: theme.palette.background.paper,
          boxShadow: theme.colors?.shadows?.card ?? theme.shadows[4],
          border: `1px solid ${alpha(theme.palette.primary.main, 0.12)}`,
        }}
      >
        <Box
          sx={{
            position: 'relative',
            display: 'inline-flex',
            mb: 3,
          }}
        >
          <Box
            component="img"
            alt=""
            src="/static/images/status/coming-soon.svg"
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: { xs: 120, sm: 150 },
              height: { xs: 120, sm: 150 },
              opacity: 0.12,
              pointerEvents: 'none',
            }}
          />
         
        </Box>

        <Typography
          variant="h3"
          component="h1"
          sx={{
            fontWeight: 700,
            fontSize: { xs: '1.5rem', sm: '1.85rem' },
            color: theme.palette.text.primary,
            mb: 2,
            lineHeight: 1.3,
          }}
        >
          🚀 Integrated GST Filing
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            fontSize: { xs: '0.95rem', sm: '1.05rem' },
            lineHeight: 1.7,
            mb: 2,
          }}
        >
          You will soon be able to file GSTR1 and GSTR3B directly from scaffoldingapp.com with just one click.
          This feature is currently under development and is expected to launch by <strong>30 July 2026</strong>.
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            fontSize: { xs: '0.95rem', sm: '1.05rem' },
            lineHeight: 1.7,
            mb: 3,
          }}
        >
          Meanwhile, you can generate GST data by exporting{' '}
          <strong>Excel/PDF reports</strong> from the Invoice Register page.
        </Typography>

        <Button
          component={RouterLink}
          to={ApplicationLinks.allBillsLink()}
          variant="contained"
          size="large"
          sx={{
            px: 3,
            py: 1.25,
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '1rem',
            boxShadow: `0 4px 14px ${alpha(theme.palette.primary.main, 0.3)}`,
            '&:hover': {
              boxShadow: `0 6px 20px ${alpha(theme.palette.primary.main, 0.4)}`,
            },
          }}
        >
          Go to Invoice Register
        </Button>
      </Box>
    </Box>
  )
}

export default GstFilingComingSoon
